// Module
var code = "<price p-id=\"pId\" p-type=\"{{pType}}\" services-prices=\"servicesPrices\" accessories-prices=\"accessoriesPrices\" segment-type=\"segmentType\"> </price>";
// Exports
module.exports = code;